module.exports = __webpack_public_path__ + "static/media/fisdom_logo_coloured.b29b9a71.svg";